import Card, { CardProps } from './Card';

export type { CardProps };
export default Card;
